const WORDS = ["Esserci", "Insieme", "Sempre e ovunque", "Nexus organizza", "Nexus coordina", "Nexus c'è"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 text-4xl font-light uppercase tracking-[0.12em] text-navy md:text-6xl">{w}</span>
        <span className="h-2.5 w-2.5 rotate-45 bg-gold" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="slogan-marquee" className="overflow-hidden border-y border-navy/10 bg-white py-8 md:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
